// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3mBcI","name":"ConsentHeader_name__1hNpw","birthday":"ConsentHeader_birthday__2MJEQ","skeleton":"ConsentHeader_skeleton__3oWyf"};